import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a GA4 page_view event on every React Router navigation.
 *
 * The gtag.js loader in index.html is configured with `send_page_view: false`,
 * so we own the page_view lifecycle here. Consent Mode is set in index.html;
 * gtag will silently drop the event if `analytics_storage` is still 'denied'.
 */
const RouteAnalytics = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
};

export default RouteAnalytics;
